import { render, staticRenderFns } from "./TableFooter.vue?vue&type=template&id=bd87e7ca&scoped=true&"
import script from "./TableFooter.vue?vue&type=script&lang=ts&"
export * from "./TableFooter.vue?vue&type=script&lang=ts&"
import style0 from "./TableFooter.vue?vue&type=style&index=0&id=bd87e7ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd87e7ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCol,VIcon,VRow})
